import axios, { AxiosRequestConfig, AxiosResponse } from "axios"

import {
  getItemFromLocalStorage,
  setItemToLocalStorage,
} from "utils/localStorage"
import history from "utils/history"
import { LANGS } from "types/shared"
import { toast } from "react-toastify"
import moment from "moment"

const getTimezone = () => {
  const timezone = moment().local().format("Z")
  let formattedTimezone = timezone.replace(":", ".")

  if (parseInt(formattedTimezone.substring(1, 2)) === 0) {
    formattedTimezone =
      formattedTimezone.slice(0, 1) +
      formattedTimezone.slice(2, 3) +
      formattedTimezone.slice(3, 4) +
      formattedTimezone.slice(4, 5)
  }

  return formattedTimezone
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})

api.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const token = getItemFromLocalStorage("token")
    const language = getItemFromLocalStorage("lang")

    if (config.headers && token) {
      config.headers["Authorization"] = `Bearer ${token}`
      config.headers["language"] = language || LANGS.KA
      config.headers.timezone = getTimezone()
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

api.interceptors.response.use(
  (res: AxiosResponse) => {
    return res
  },
  (error) => {
    if (error && error.response.status === 401) {
      setItemToLocalStorage("token", "")
      history.push("/login")
    }

    if (error && error.response.status === 500) {
      console.log("error", error)
      toast.error("general.internal_server_error")
    }

    return Promise.reject(error)
  },
)

export default api
